import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Warehouse,
  Clock,
  CheckCircle2,
  MapPin,
  Bus,
  Train,
  Landmark,
  Navigation,
  Compass,
  Footprints,
  Route,
  ArrowUp,
} from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import baseapi from '../baseapi';
import rajivImg from '../assets/darshan/rajiv_gandhi_park.jpg';
import prakasamImg from '../assets/darshan/prakasam_statue.jpg';
import railwayImg from '../assets/darshan/railway_station.jpg';
import busImg from '../assets/darshan/bus_stand.jpg';
import kummariImg from '../assets/darshan/kummaripalem.jpg';

const VINAYAKA_QR_DATA = {
  id: 'VINAYAKA Q LINE',
  title: 'Scan for Vinayaka Temple Q Line Entry',
  subtitle: 'Direct Google Maps navigation to Vinayaka Temple Q Line',
  url: 'https://www.google.com/maps?q=16.512247,80.610933',
  panelClass: 'border-t-[3px] border-t-[#dfb052]',
  badgeClass:
    'bg-amber-500/15 text-amber-600 dark:bg-[rgba(223,176,82,0.35)] dark:text-[#f6d887] border border-amber-500/30 dark:border-[rgba(223,176,82,0.5)]',
  qrImg:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAABlBMVEX///8AAABVwtN+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAB9UlEQVRoge2aO26EMBCGB21ByRE4CkeDo3EUH4GSAtmZl02INtHGWpMU/xRgzFfxax6egQj2H2xKZjtRWmVjXunBz0GvaiuweizoVx73jp8H3lym7RF5Y3skEwDYHVgveowilkrmptic0gHsLdipQkqRZvEFYLdjst76mCNS+lZTYC0w8xAWizFe6aufAhew32DJzDBVYTi6tAjmBqw5drGBY1GWbPv6Elg7zMRaR71t1JW8MHAsWsbdHQdYHUbEAV+ukSTtasBn2C1QLvyBNcU04ZKKlQGLSBdfANYeMz2EiJ6dtQT97DLA6jCHUyRTwSJS2T4I2A2Ye0EfPUcsujvLUiQrEQlYU0xd5nSc2XI0mcucYgGrwfwYa2up8LnCPCTsb7l7Caw9liXTKDTsJlN0L1ieBS5g78cm7dqwKqXsXGWbDwKyDn1u6QCrw4J95NIx46vGIr1SXyISsKaYrcppSyISWWPtGriAtcRkNZm35J6D5mVzmVTGhcAqsGKdwtac1zkgeYUJrD3mMmn32Mzgc0SSN4E1xILebGjreYFy93gOWUpgtZjPAW1QVZoJo2oTLA8AuxEjnYlTMavwPX0AuwnjElQlOsqhQOyJpsBex/SmP37Y7zeTz8TpMs8C1hRzSc6IRHbO9T/9nmRnYG/HYH9vH8kU6MqS8lRZAAAAAElFTkSuQmCC',
};

const HOLDING_QR_DATA = [
  {
    id: 'HA 1',
    title: 'Scan for Holding Area 1 Entry',
    url: 'https://www.google.com/maps?q=16.510676,80.61047',
    panelClass: 'border-t-[3px] border-t-[#00b4d8]',
    badgeClass:
      'bg-sky-500/15 text-sky-600 dark:bg-[rgba(0,180,216,0.35)] dark:text-[#7dd3fc] border border-sky-500/30 dark:border-[rgba(0,180,216,0.5)]',
    qrImg:
      'data:image/png;base64,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',
  },
  {
    id: 'HA 2',
    title: 'Scan for Holding Area 2 Entry',
    url: 'https://www.google.com/maps?q=16.510783,80.613317',
    panelClass: 'border-t-[3px] border-t-[#00d287]',
    badgeClass:
      'bg-emerald-500/15 text-emerald-600 dark:bg-[rgba(0,210,135,0.35)] dark:text-[#6ee7b7] border border-emerald-500/30 dark:border-[rgba(0,210,135,0.5)]',
    qrImg:
      'data:image/png;base64,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',
  },
  {
    id: 'HA 3',
    title: 'Scan for Holding Area 3 Entry',
    url: 'https://www.google.com/maps?q=16.507982,80.612615',
    panelClass: 'border-t-[3px] border-t-[#b388ff]',
    badgeClass:
      'bg-purple-500/15 text-purple-600 dark:bg-[rgba(179,136,255,0.35)] dark:text-[#d8b4fe] border border-purple-500/30 dark:border-[rgba(179,136,255,0.5)]',
    qrImg:
      'data:image/png;base64,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',
  },
];

interface RouteItem {
  holding_area_en?: string;
  holding_area_te?: string;
  holding_area_id?: string;
  path_en?: string;
  path_te?: string;
  distance_km?: number;
  walk_time_min?: number;
  holdingarea_occupied?: boolean;
  recommended?: boolean;
  expected_darshan_min?: number;
  expected_darshan_at?: string;
}

interface LocationItem {
  name_en: string;
  name_te?: string;
  routes: RouteItem[];
}

export interface DarshanPathsPageProps {
  isPublic?: boolean;
}

export const DarshanPathsPage: React.FC<DarshanPathsPageProps> = ({ isPublic }) => {
  const [timingsData, setTimingsData] = useState<any>(null);

  const location = useLocation();
  const { setTheme } = useTheme();
  const isPublicRoute =
    isPublic ?? (typeof window !== 'undefined' && location.pathname.includes('/darshan-timings/public'));

  // Fit screen is ON (true) when accessed via /darshan-timings/public; OFF (false) when accessed via /darshan-timings
  const activeFit = isPublicRoute;
  // Public display (17 Oct 2026, operators): the card texts alternate English / Telugu every 5 s, and their sizes
  // follow the screen width (vw) instead of fixed pixels - on a 100-inch TV (browser at 150-200 % zoom, far fewer
  // CSS pixels) fixed sizes collided
  const [lang, setLang] = useState<'en' | 'te'>('en');
  useEffect(() => {
    if (!isPublicRoute) return;
    const t = window.setInterval(() => setLang(l => (l === 'en' ? 'te' : 'en')), 5000);
    return () => window.clearInterval(t);
  }, [isPublicRoute]);
  const te = isPublicRoute && lang === 'te';
  // Both languages sit in the same grid cell with the one not showing kept invisible, so each block always keeps the
  // height of its taller translation. The card photos fill whatever height is left, and without this they grew and
  // shrank on every English / Telugu switch (17 Oct 2026).
  const bothLangs = (render: (te: boolean) => React.ReactNode, className = '') =>
    isPublicRoute ? (
      <div className={`grid ${className}`}>
        {[false, true].map((l) => (
          <div key={String(l)} className={`[grid-area:1/1] min-w-0 ${l === te ? '' : 'invisible'}`} aria-hidden={l !== te}>
            {render(l)}
          </div>
        ))}
      </div>
    ) : (
      render(false)
    );
  const fs = (pub: string, normal: string) => (activeFit ? pub : normal);
  const WALK_TO_VINAYAKA_Q: Record<string, number> = {
    'rajiv gandhi park': 8, 'prakasam statue': 12, 'railway station': 20, 'bus stand': 15,
  };
  const PUBLIC_PHOTO_POS: Record<string, string> = { 'prakasam statue': '50% 38%', 'rajiv gandhi park': '50% 48%' };
  const FOOTER_TE: Record<string, string> = {
    'FASTEST ROUTE': 'వేగవంతమైన మార్గం', 'SUGGESTED ROUTE': 'సూచించిన మార్గం', 'PLAN AHEAD': 'ముందుగా ప్లాన్ చేయండి',
    'EASY ACCESS': 'సులభ మార్గం', 'ALTERNATE ROUTE': 'ప్రత్యామ్నాయ మార్గం',
  };

  // Make page light theme by default when accessed through /darshan-timings/public
  useEffect(() => {
    if (isPublicRoute) {
      setTheme('light');
    }
  }, [isPublicRoute, setTheme]);

  useEffect(() => {
    let alive = true;
    let inFlight = false;
    const load = () => {
      if (inFlight) return;
      inFlight = true;

      baseapi
        .get('darshan/timings')
        .then((res) => {
          if (alive && res?.data) {
            setTimingsData(res.data);
          }
        })
        .finally(() => {
          inFlight = false;
        });
    };

    load();
    const t = window.setInterval(() => {
      if (!document.hidden) load();
    }, 10000); // every 10 seconds
    const onShow = () => {
      if (!document.hidden) load();
    };
    document.addEventListener('visibilitychange', onShow);
    return () => {
      alive = false;
      window.clearInterval(t);
      document.removeEventListener('visibilitychange', onShow);
    };
  }, []);

  const n = (v: number | null | undefined) =>
    v == null ? '—' : Math.round(v).toLocaleString('en-IN');

  const fmtMin = (m: number | null | undefined) => {
    if (m == null) return '—';
    const total = Math.round(m);  // round first: 179.6 is 3 h 00 m, not 2 h 60 m
    const h = Math.floor(total / 60);
    const min = total % 60;
    // two-digit minutes so the times in a card's route list line up (17 Oct 2026)
    return h > 0 ? `${h} h ${String(min).padStart(2, '0')} m` : `${min} min`;
  };

  const formatClock = (isoStr?: string) => {
    if (!isoStr) return null;
    try {
      const d = new Date(isoStr);
      if (isNaN(d.getTime())) return null;
      return d.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,                     // 24-hour clock (operators, 16 Oct 2026)
        timeZone: 'Asia/Kolkata',
      });
    } catch {
      return null;
    }
  };

  // Count KPIs from /darshan/timings; waiting time is averaged from the same current-hour
  // Vinayaka and Kummaripalem journey estimates shown on Darshan Evidence.
  const summary: any = timingsData?.summary ?? {};
  const totalCompleted: number | null = summary.total_darshan_completed ?? null;
  const holdingCount: number | null = summary.devotees_in_holding_areas ?? null;
  const holdingAreaCounts: Record<string, number> | null =
    summary.holding_area_counts ?? null;
  // never blank on the public display: the API's summary average, then the two-queue average (17 Oct 2026)
  // Same figure as the Darshan Time Evidence page's "Estimated Darshan Time" (Vinayaka queue entry -> Antharalayam
  // exit, verified devotees, API darshan_evidence_wait); the older averages only as fallbacks (operators, 17 Oct 2026)
  const avgExpDarshanMin: number | null =
    summary.avg_darshan_evidence_min ?? timingsData?.darshan_evidence_wait?.display_minutes ??
    summary.vinayaka_darshan_evidence_min ?? summary.avg_estimated_darshan_wait_min ??
    timingsData?.estimated_darshan_wait?.average_min ?? null;

  // Locations list strictly from /darshan/timings API (no dummy fallback data)
  const rawLocations: LocationItem[] =
    timingsData?.locations && Array.isArray(timingsData.locations)
      ? timingsData.locations
      : [];

  // A card lists its holding-area routes while at least one of them is occupied; only when every route says
  // "holdingarea_occupied": false does it fall back to the direct Vinayaka Q line. Kummaripalem has its own queue
  // and never lists holding areas (operators, 17 Oct 2026).
  const isKummari = (loc: LocationItem) => loc.name_en.toLowerCase().includes('kummari');
  const showsHoldingRoutes = (loc: LocationItem) =>
    !isKummari(loc) && Array.isArray(loc.routes) && loc.routes.length > 0 &&
    !loc.routes.every((r) => r.holdingarea_occupied === false);
  const anyHoldingRoutes = rawLocations.some(showsHoldingRoutes);

  const getLocationIconInfo = (nameEn: string, idx: number) => {
    const s = nameEn.toLowerCase();
    if (s.includes('rajiv') || s.includes('park')) {
      return {
        number: '1',
        displayTitle: 'RAJIV GANDHI PARK',
        subtitle: 'Toward Kanaka Durga Temple',
        icon: MapPin,
        photo: rajivImg,
        photoPosition: 'top',
        headerBg: 'bg-emerald-600 dark:bg-emerald-700',
        cardBorder: 'border-emerald-500/30 dark:border-emerald-500/30',
        accentColor: 'text-emerald-600 dark:text-emerald-400',
        footerBg: 'bg-emerald-50 dark:bg-emerald-950/40',
        footerLabel: 'FASTEST ROUTE',
      };
    }
    if (s.includes('prakasam') || s.includes('statue')) {
      return {
        number: '2',
        displayTitle: 'PRAKASAM STATUE',
        subtitle: 'Toward Kanaka Durga Temple',
        icon: Landmark,
        photo: prakasamImg,
        photoPosition: 'top',
        headerBg: 'bg-sky-600 dark:bg-sky-700',
        cardBorder: 'border-sky-500/30 dark:border-sky-500/30',
        accentColor: 'text-sky-600 dark:text-sky-400',
        footerBg: 'bg-sky-50 dark:bg-sky-950/40',
        footerLabel: 'SUGGESTED ROUTE',
      };
    }
    if (s.includes('rail') || s.includes('train') || s.includes('station')) {
      return {
        number: '3',
        displayTitle: 'RAILWAY STATION',
        subtitle: 'Toward Kanaka Durga Temple',
        icon: Train,
        photo: railwayImg,
        photoPosition: 'top',
        headerBg: 'bg-orange-600 dark:bg-orange-700',
        cardBorder: 'border-orange-500/30 dark:border-orange-500/30',
        accentColor: 'text-orange-600 dark:text-orange-400',
        footerBg: 'bg-orange-50 dark:bg-orange-950/40',
        footerLabel: 'PLAN AHEAD',
      };
    }
    if (s.includes('bus')) {
      return {
        number: '4',
        displayTitle: 'BUS STAND',
        subtitle: 'Toward Kanaka Durga Temple',
        icon: Bus,
        photo: busImg,
        photoPosition: 'top',
        headerBg: 'bg-purple-700 dark:bg-purple-800',
        cardBorder: 'border-purple-500/30 dark:border-purple-500/30',
        accentColor: 'text-purple-600 dark:text-purple-400',
        footerBg: 'bg-purple-50 dark:bg-purple-950/40',
        footerLabel: 'EASY ACCESS',
      };
    }
    if (s.includes('kummari')) {
      return {
        number: '5',
        displayTitle: 'KUMMARIPALEM',
        subtitle: 'Toward Kanaka Durga Temple',
        icon: Navigation,
        photo: kummariImg,
        photoPosition: 'top',
        headerBg: 'bg-[#9e1b20] dark:bg-[#7a1518]',
        cardBorder: 'border-rose-500/30 dark:border-rose-500/30',
        accentColor: 'text-[#9e1b20] dark:text-rose-400',
        footerBg: 'bg-rose-50 dark:bg-rose-950/40',
        footerLabel: 'ALTERNATE ROUTE',
        isDirect: true,
      };
    }
    return {
      number: String(idx + 1),
      displayTitle: nameEn.toUpperCase(),
      subtitle: 'Toward Kanaka Durga Temple',
      icon: Navigation,
      photo: rajivImg,
      photoPosition: 'top',
      headerBg: 'bg-blue-600 dark:bg-blue-700',
      cardBorder: 'border-blue-500/30 dark:border-blue-500/30',
      accentColor: 'text-blue-600 dark:text-blue-400',
      footerBg: 'bg-blue-50 dark:bg-blue-950/40',
      footerLabel: 'APPROACH ROUTE',
    };
  };

  return (
    <div className={`w-full ${activeFit ? 'h-[calc(100vh-3.85rem)] max-h-[calc(100vh-3.85rem)] flex flex-col justify-between overflow-hidden gap-1 pb-0' : 'space-y-3 pb-8'}`}>
      {/* Page Header */}
      <div className={`flex flex-wrap items-center justify-between ${activeFit ? 'gap-1.5 pt-0 shrink-0' : 'gap-3 pt-1'}`}>
        <div>
          <div className="flex items-center gap-2">
            <span className="p-1.5 rounded-lg bg-[#761D20]/10 dark:bg-amber-400/10 text-[#761D20] dark:text-amber-400 border border-[#761D20]/20 dark:border-amber-400/20">
              <Route className={`${fs('w-[1.3vw] h-[1.3vw]', 'w-5 h-5')} stroke-[2.2]`} />
            </span>
            <h1 className={`${fs('text-[1.5vw]', 'text-xl sm:text-2xl')} font-black text-neutral-900 dark:text-neutral-100 tracking-tight`}>
              Darshan Path Timings
            </h1>
          </div>
        </div>

      </div>

      {/* 1. TOP KPI CARDS (from /darshan/timings summary) */}
      <div className={`grid ${activeFit ? 'grid-cols-3 gap-[0.6vw] shrink-0' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3'}`}>

        <div className={`rounded-2xl bg-white dark:bg-[#151720] border border-neutral-200/90 dark:border-[#262b37] shadow-xs hover:border-[#761D20]/40 dark:hover:border-teal-500/40 hover:shadow-sm transition-all flex items-center justify-between gap-3 ${activeFit ? 'p-2 sm:p-2.5 px-3 sm:px-3.5' : 'p-3 sm:p-3.5 px-4'}`}>
          {/* Left Side: Heading & Subtitle */}
          <div className="flex-1 min-w-0 flex flex-col justify-center">
            <div className="flex items-center gap-1.5">
              <span className="p-1 rounded-md bg-teal-500/10 text-teal-600 dark:text-teal-400 border border-teal-500/20 shrink-0">
                <CheckCircle2 className={`${fs('w-[1vw] h-[1vw]', 'w-3.5 h-3.5')} stroke-[2.5]`} />
              </span>
              <span className={`${fs('text-[1.15vw]', 'text-xl')} font-black text-neutral-800 dark:text-neutral-200 uppercase tracking-tight break-words leading-tight`} title="Devotees who completed darshan today">
                Total Darshan Completed
              </span>
            </div>
            <div className={`mt-1 ${fs('text-[0.8vw]', 'text-xs')} text-neutral-600 dark:text-neutral-400 font-bold leading-snug break-words`}>
              Devotees who finished darshan today
            </div>
          </div>

          {/* Right Side: Data */}
          <div className="shrink-0 text-right pl-2">
            <div className={`${fs('text-[2.4vw]', 'text-3xl sm:text-4xl lg:text-[40px]')} font-black text-neutral-900 dark:text-neutral-50 tracking-tight leading-none tabular-nums`}>
              {n(totalCompleted)}
            </div>
          </div>
        </div>
        {/* Card 2: Devotees in Holding Areas */}
        <div className={`rounded-2xl bg-white dark:bg-[#151720] border border-neutral-200/90 dark:border-[#262b37] shadow-xs hover:border-[#761D20]/40 dark:hover:border-emerald-500/40 hover:shadow-sm transition-all flex items-center justify-between gap-3 ${activeFit ? 'p-2 sm:p-2.5 px-3 sm:px-3.5' : 'p-3 sm:p-3.5 px-4'}`}>
          {/* Left Side: Heading & Subtitle */}
          <div className="flex-1 min-w-0 flex flex-col justify-center">
            <div className="flex items-center gap-1.5">
              <span className="p-1 rounded-md bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20 shrink-0">
                <Warehouse className={`${fs('w-[1vw] h-[1vw]', 'w-3.5 h-3.5')} stroke-[2.5]`} />
              </span>
              <span className={`${fs('text-[1.15vw]', 'text-xl')} font-black text-neutral-800 dark:text-neutral-200 uppercase tracking-tight break-words leading-tight`} title="Devotees waiting in holding areas now">
                Devotees in Holding Areas
              </span>
            </div>
            <div className={`mt-1 ${fs('text-[0.8vw]', 'text-xs')} text-neutral-600 dark:text-neutral-300 font-bold leading-snug break-words`}>
              {holdingAreaCounts && Object.keys(holdingAreaCounts).length > 0 ? (
                <span className="flex items-center gap-1.5 flex-wrap">
                  {Object.entries(holdingAreaCounts).map(([id, count], idx, arr) => (
                    <React.Fragment key={id}>
                      <span>
                        {id}: <strong className="font-black text-neutral-900 dark:text-neutral-100">{n(count)}</strong>
                      </span>
                      {idx < arr.length - 1 && <span className="text-neutral-400">·</span>}
                    </React.Fragment>
                  ))}
                </span>
              ) : (
                'Now · HA-1, HA-2, HA-3'
              )}
            </div>
          </div>

          {/* Right Side: Data */}
          <div className="shrink-0 text-right pl-2">
            <div className={`${fs('text-[2.4vw]', 'text-3xl sm:text-4xl lg:text-[40px]')} font-black text-emerald-600 dark:text-emerald-400 tracking-tight leading-none tabular-nums`}>
              {n(holdingCount)}
            </div>
          </div>
        </div>

        {/* Card 3: Estimated Darshan Waiting Time */}
        <div className={`rounded-2xl bg-white dark:bg-[#151720] border border-neutral-200/90 dark:border-[#262b37] shadow-xs hover:border-[#761D20]/40 dark:hover:border-violet-500/40 hover:shadow-sm transition-all flex items-center justify-between gap-3 ${activeFit ? 'p-2 sm:p-2.5 px-3 sm:px-3.5' : 'p-3 sm:p-3.5 px-4'}`}>
          {/* Left Side: Heading & Subtitle */}
          <div className="flex-1 min-w-0 flex flex-col justify-center">
            <div className="flex items-center gap-1.5">
              <span className="p-1 rounded-md bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20 shrink-0">
                <Clock className={`${fs('w-[1vw] h-[1vw]', 'w-3.5 h-3.5')} stroke-[2.5]`} />
              </span>
              <span className={`${fs('text-[1.15vw]', 'text-xl')} font-black text-neutral-800 dark:text-neutral-200 uppercase tracking-tight break-words leading-tight`} title="Estimated darshan waiting time">
                Avg Estimated Darshan Time
              </span>
            </div>
            <div className={`mt-1 ${fs('text-[0.8vw]', 'text-xs')} text-neutral-600 dark:text-neutral-400 font-bold leading-snug break-words`}>
              {bothLangs((te) => (te ? 'క్యూ ప్రవేశం → అంతరాలయం నిష్క్రమణ · కెమెరా ధృవీకరణ' : 'Queue entry → Antharalayam exit · camera verified'))}
            </div>
          </div>

          {/* Right Side: Data */}
          <div className="shrink-0 text-right pl-2">
            <div className={`${fs('text-[2.4vw]', 'text-3xl sm:text-4xl lg:text-[40px]')} font-black text-[#8A6508] dark:text-amber-400 tracking-tight leading-none tabular-nums whitespace-nowrap`}>
              {fmtMin(avgExpDarshanMin)}
            </div>
          </div>
        </div>

        {/* Card 4: Total Darshan Completed */}
        
      </div>

      {/* 2. THE 5 APPROACH ROUTE CARDS FROM /darshan/timings */}
      <div className={activeFit ? 'flex-1 min-h-0 flex flex-col pt-0' : 'pt-2'}>
        <div className={`flex items-center justify-between ${activeFit ? 'pb-0.5 shrink-0' : 'pb-2'}`}>
          <h2 className={`${fs('text-[1.3vw]', 'text-base sm:text-lg')} font-black text-neutral-900 dark:text-neutral-100 tracking-tight flex items-center gap-2`}>
            <Compass className={`${fs('w-[1.3vw] h-[1.3vw]', 'w-4 h-4 sm:w-5 sm:h-5')} text-[#761D20] dark:text-amber-400 stroke-[2.2]`} />
            {bothLangs((te) => <span>{te ? 'చేరుకునే ప్రదేశాలు & ప్రత్యక్ష దర్శన అంచనా సమయం' : 'Approach Points & Real-Time Darshan ETA'}</span>)}
          </h2>
          <span className={`${fs('text-[0.8vw]', 'text-xs')} font-bold text-neutral-500 dark:text-neutral-400`}>
            {rawLocations.length} Locations via Live Guidance
          </span>
        </div>

        {rawLocations.length === 0 ? (
          <div className="rounded-2xl bg-white dark:bg-[#151720] border border-neutral-200/90 dark:border-[#262b37] p-8 text-center my-2 shadow-xs">
            <div className="inline-flex p-3 rounded-full bg-[#761D20]/10 dark:bg-amber-400/10 text-[#761D20] dark:text-amber-400 mb-3 animate-pulse">
              <Route className="w-6 h-6 stroke-[2.2]" />
            </div>
            <div className="text-sm sm:text-base font-black text-neutral-800 dark:text-neutral-200">
              Connecting to live /darshan/timings API...
            </div>
            <div className="text-xs font-semibold text-neutral-500 dark:text-neutral-400 mt-1">
              Real-time approach path timings will appear here once live telemetry is received.
            </div>
          </div>
        ) : (
          <div className={`grid ${activeFit ? 'grid-cols-5 gap-[0.6vw] flex-1 min-h-0' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-3.5'}`}>
            {rawLocations.map((loc, idx) => {
              const info = getLocationIconInfo(loc.name_en, idx);
              const Icon = info.icon;

              const isKummaripalem = isKummari(loc);
              // No occupied holding area on this card's routes: show the direct Vinayaka Q line instead of HA 1, 2, 3
              const isVinayakaDirectCard = !isKummaripalem && !showsHoldingRoutes(loc);

              const vinayakaOnlyMin: number =
                (loc.routes as any[])?.find((r: any) => r.darshan_from_vinayaka_min != null)
                  ?.darshan_from_vinayaka_min ??
                timingsData?.onward_darshan?.duration_min ??
                timingsData?.estimated_darshan_wait?.vinayaka?.minutes ??
                148.5;
              // Walk from the point straight to the Vinayaka Q line is part of the darshan time (operators, 17 Oct 2026:
              // 8 / 12 / 20 / 15 min). The API gives it in `direct`; the table is the fallback until it does.
              const walkToQMin: number =
                (loc as any).direct?.walk_to_vinayaka_q_min ?? (WALK_TO_VINAYAKA_Q[loc.name_en.toLowerCase()] ?? 0);
              const vinayakaMin: number = (loc as any).direct?.expected_darshan_min ?? vinayakaOnlyMin + walkToQMin;

              /* Compute fastest (minimum) route time for footer */
              const allMins = loc.routes
                .map((r) => r.expected_darshan_min)
                .filter((m): m is number => m != null);
              const fastestMin = isVinayakaDirectCard
                ? vinayakaMin
                : allMins.length > 0
                ? Math.min(...allMins)
                : null;

              return (
                <div
                  key={loc.name_en}
                  className={`rounded-2xl overflow-hidden border ${info.cardBorder} shadow-xs hover:shadow-md transition-all flex flex-col ${activeFit ? 'h-full min-h-0 justify-between' : ''}`}
                >
                  {/* ── Colored Header Band ── */}
                  <div className={`${info.headerBg} ${activeFit ? 'px-[0.7vw] py-[0.8vh]' : 'px-3 py-2.5'} text-white flex items-start gap-1.5 shrink-0`}>
                    <div className="p-1 rounded-lg bg-white/20 shrink-0 mt-0.5">
                      <Icon className={`${fs('w-[1.1vw] h-[1.1vw]', 'w-4 h-4')} text-white stroke-[2.5]`} />
                    </div>
                    {bothLangs((te) => (<div>
                      <h3 className={`${fs('text-[1.25vw]', 'text-sm sm:text-[15px]')} font-black uppercase tracking-wide leading-snug break-words`}>
                        {te && loc.name_te ? loc.name_te : info.displayTitle}
                      </h3>
                      <p className={`${fs('text-[0.95vw]', 'text-xs')} font-semibold text-white/90 leading-tight break-words mt-0.5`}>
                        {te ? 'కనక దుర్గ ఆలయం వైపు' : info.subtitle}
                      </p>
                      {loc.name_te && (
                        <p className={`${fs('text-[0.9vw]', 'text-xs')} font-medium text-white/80 leading-tight break-words mt-0.5`}>
                          {te ? info.displayTitle : loc.name_te}
                        </p>
                      )}
                    </div>), 'min-w-0 flex-1')}
                  </div>

                  {/* ── Photo Banner: on the public display it takes whatever height the body leaves, so a card without
                       a route list shows a larger photo instead of empty space (17 Oct 2026) ── */}
                  <div className={`relative w-full overflow-hidden border-b border-neutral-200/80 dark:border-[#242938] ${activeFit ? 'flex-1 min-h-[7vh] bg-neutral-100 dark:bg-neutral-900' : 'shrink-0 h-28 sm:h-32 bg-neutral-100 dark:bg-neutral-900'}`}>
                    <img
                      src={info.photo}
                      alt={info.displayTitle}
                      className={`${activeFit ? 'absolute inset-0' : ''} w-full h-full object-cover object-top`}
                      style={{ objectPosition: activeFit ? (PUBLIC_PHOTO_POS[loc.name_en.toLowerCase()] || '50% 62%') : (info.photoPosition || 'top') }}  /* public strip is short: show the landmark, not the sky (17 Oct 2026) */
                      loading="lazy"
                    />
                  </div>

                  {/* ── Public display body (17 Oct 2026): holding-area cards list HA 1/2/3 with their own darshan time;
                       direct cards (Vinayaka Q line, Kummaripalem) show one time, centred ── */}
                  {activeFit ? bothLangs((te) => {
                    const routePill = (
                      <span className={`self-center inline-flex items-center gap-[0.4vw] rounded-full px-[0.8vw] py-[0.3vh] text-[0.85vw] font-black uppercase tracking-wide whitespace-nowrap ${info.footerBg} ${info.accentColor} border border-current/20`}>
                        <ArrowUp className="w-[0.85vw] h-[0.85vw] stroke-[2.8]" />
                        {te ? (FOOTER_TE[info.footerLabel] || info.footerLabel) : info.footerLabel}
                      </span>
                    );

                    if (!isVinayakaDirectCard && !isKummaripalem) {
                      const timed = loc.routes.filter((r) => r.expected_darshan_min != null);
                      const best =
                        loc.routes.find((r) => r.recommended) ??
                        (timed.length ? timed.reduce((a, b) => (b.expected_darshan_min! < a.expected_darshan_min! ? b : a)) : null);
                      return (
                        <div className="bg-white dark:bg-[#151720] shrink-0 flex flex-col px-[0.6vw] pt-[1vh] pb-[1.2vh] gap-[0.7vh]">
                          <div className="flex items-end justify-between gap-2 px-[0.2vw] text-[0.75vw] font-black uppercase tracking-wider text-neutral-500 dark:text-neutral-400">
                            <span>{te ? 'హోల్డింగ్ ఏరియా ద్వారా' : 'Via holding area'}</span>
                            <span>{te ? 'దర్శనానికి సమయం' : 'Time to darshan'}</span>
                          </div>
                          {/* One colour, one meaning on every card: green marks the fastest route, the rest stay neutral
                              (operators, 17 Oct 2026) */}
                          {loc.routes.map((route, rIdx) => {
                            const haNum = Number(String(route.holding_area_id ?? '').replace(/\D/g, '')) || rIdx + 1;
                            const isBest = route === best;
                            const mins = route.expected_darshan_min;
                            const at =
                              formatClock(route.expected_darshan_at) ??
                              (mins != null ? formatClock(new Date(Date.now() + mins * 60000).toISOString()) : null);
                            const walk = [
                              route.walk_time_min != null ? (te ? `${Math.round(route.walk_time_min)} ని` : `${Math.round(route.walk_time_min)} min`) : null,
                              route.distance_km != null ? (te ? `${route.distance_km} కి.మీ` : `${route.distance_km} km`) : null,
                            ].filter(Boolean).join(' · ');
                            return (
                              <div
                                key={route.holding_area_id ?? rIdx}
                                className={`flex items-center justify-between gap-[0.5vw] rounded-[0.6vw] px-[0.6vw] py-[0.9vh] ${isBest ? 'bg-emerald-50 dark:bg-emerald-950/40 ring-2 ring-inset ring-emerald-500/60' : 'bg-neutral-50 dark:bg-[#10121a]'}`}
                              >
                                <div className="min-w-0 flex flex-col gap-[0.4vh]">
                                  <div className="flex items-center gap-[0.4vw]">
                                    <span className={`text-[1vw] font-black px-[0.45vw] py-[0.1vh] rounded-[0.35vw] tracking-wider whitespace-nowrap ${isBest ? 'bg-emerald-600 text-white' : 'bg-neutral-200/80 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-100'}`}>
                                      HA {haNum}
                                    </span>
                                    {isBest && (
                                      <span className="text-[0.7vw] font-black uppercase tracking-wide whitespace-nowrap text-emerald-700 dark:text-emerald-400">
                                        {te ? 'వేగవంతం' : 'Fastest'}
                                      </span>
                                    )}
                                  </div>
                                  {walk && (
                                    <span className="flex items-center gap-[0.25vw] text-[0.75vw] font-bold text-neutral-500 dark:text-neutral-400 whitespace-nowrap tabular-nums">
                                      <Footprints className="w-[0.8vw] h-[0.8vw] shrink-0" />
                                      {walk}
                                    </span>
                                  )}
                                </div>
                                <div className="text-right shrink-0">
                                  <div className={`text-[1.75vw] font-black tabular-nums leading-none whitespace-nowrap ${isBest ? 'text-emerald-700 dark:text-emerald-400' : 'text-neutral-900 dark:text-neutral-100'}`}>
                                    {mins != null ? fmtMin(mins) : '—'}
                                  </div>
                                  {at && (
                                    <div className="text-[0.8vw] font-bold text-neutral-500 dark:text-neutral-400 tabular-nums leading-tight mt-[0.4vh] whitespace-nowrap">
                                      {te ? `సుమారు ${at}` : `around ${at}`}
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    }

                    const routeMins = loc.routes.map((r) => r.expected_darshan_min).filter((m): m is number => m != null);
                    const mainMin = isVinayakaDirectCard ? vinayakaMin : routeMins.length ? Math.min(...routeMins) : null;
                    const walkEn = walkToQMin > 0 ? `Walk ${Math.round(walkToQMin)} min → ` : '';
                    const walkTe = walkToQMin > 0 ? `నడక ${Math.round(walkToQMin)} ని → ` : '';
                    const routeEn = isKummaripalem ? 'Kummaripalem Q Line → Darshan' : `${walkEn}Vinayaka Temple Q Line → Darshan`;
                    const routeTe = isKummaripalem ? 'కుమ్మరిపాలెం క్యూ లైన్ → దర్శనం' : `${walkTe}వినాయక గుడి క్యూ లైన్ → దర్శనం`;
                    const arrival = formatClock(new Date(Date.now() + (mainMin ?? 0) * 60000).toISOString());
                    return (
                      <div className="bg-white dark:bg-[#151720] shrink-0 flex flex-col items-center text-center px-[0.8vw] pt-[1.6vh] pb-[1.8vh] gap-[0.5vh]">
                        <span className="text-[0.95vw] font-black uppercase tracking-wider text-neutral-500 dark:text-neutral-400">
                          {te ? 'దర్శనానికి అంచనా సమయం' : 'Expected time to darshan'}
                        </span>
                        <span className="text-[3.4vw] font-black text-neutral-900 dark:text-neutral-100 tabular-nums leading-none">
                          {mainMin != null ? fmtMin(mainMin) : '—'}
                        </span>
                        {mainMin != null && arrival && (
                          <span className="text-[1vw] font-bold text-neutral-500 dark:text-neutral-400 tabular-nums">
                            {te ? `దర్శనం సుమారు ${arrival}` : `Darshan around ${arrival}`}
                          </span>
                        )}
                        <span className="text-[1.1vw] font-extrabold text-neutral-800 dark:text-neutral-200 leading-snug mt-[0.6vh]">
                          {te ? routeTe : routeEn}
                        </span>
                        <span className="text-[0.9vw] font-semibold text-neutral-500 dark:text-neutral-400 leading-snug">
                          {te ? routeEn : routeTe}
                        </span>
                        <div className="mt-[0.8vh]">{routePill}</div>
                      </div>
                    );
                  }, 'shrink-0') : (<>
                  {/* ── Table ── */}
                  <div className="bg-white dark:bg-[#151720] flex-1 flex flex-col justify-between">
                    {/* Table Header */}
                    <div className={`grid grid-cols-2 ${activeFit ? 'px-2.5 py-1' : 'px-3 py-1.5'} bg-neutral-50/90 dark:bg-[#10121a] border-b border-neutral-200/70 dark:border-[#242938] ${fs('text-[0.9vw]', 'text-[11px] sm:text-xs')} font-black uppercase tracking-wider text-neutral-600 dark:text-neutral-400 shrink-0`}>
                      {/* Kummaripalem devotees walk straight into their own queue: a direct queue, not a holding area (operators, 17 Oct 2026) */}
                      <span>{(isVinayakaDirectCard || isKummaripalem) ? (te ? 'నేరుగా క్యూ' : 'DIRECT QUEUE') : (te ? 'హోల్డింగ్ ఏరియా ద్వారా' : 'VIA HOLDING AREA')}</span>
                      <span className="text-right">{te ? 'దర్శనానికి అంచనా సమయం' : 'EST. TIME TO DARSHAN'}</span>
                    </div>

                    {/* Table Rows */}
                    <div className="divide-y divide-neutral-100 dark:divide-[#202534] flex-1 flex flex-col justify-center">
                      {isVinayakaDirectCard ? (
                        <div
                          className={`grid grid-cols-2 items-center ${activeFit ? 'px-2.5 py-3 sm:py-4 flex-1' : 'px-3 py-3 sm:py-4'} hover:bg-neutral-50/70 dark:hover:bg-[#191c28] transition-colors`}
                        >
                          <div className="min-w-0 pr-1.5">
                            <span className={`${fs('text-[1.35vw]', 'text-sm sm:text-base')} font-extrabold text-neutral-900 dark:text-neutral-100 block break-words leading-snug`}>
                              {te ? 'వినాయక గుడి క్యూ లైన్ → దర్శనం' : 'Vinayaka Temple Q Line → Darshan'}
                            </span>
                            <div className={`${fs('text-[1vw]', 'text-xs')} font-semibold text-neutral-500 dark:text-neutral-400 break-words leading-tight mt-0.5`}>
                              {te ? 'Vinayaka Temple Q Line → Darshan' : 'వినాయక గుడి క్యూ లైన్'}
                            </div>
                          </div>
                          <div className="text-right pl-1">
                            <div className={`${fs('text-[2.2vw]', 'text-base sm:text-lg lg:text-xl')} font-black text-neutral-900 dark:text-neutral-100 tabular-nums leading-tight`}>
                              {fmtMin(vinayakaMin)}
                            </div>
                            <div className={`${fs('text-[0.95vw]', 'text-[11px] sm:text-xs')} font-bold text-emerald-600 dark:text-emerald-400 tabular-nums leading-tight mt-0.5`}>
                              {te ? 'ప్రత్యక్ష క్యూ · ఇప్పుడు' : 'Direct live queue'}{walkToQMin > 0 ? ` · incl. ${Math.round(walkToQMin)} min walk` : ''}
                            </div>
                          </div>
                        </div>
                      ) : (
                        loc.routes.map((route, rIdx) => {
                          const pathLabel =
                            route.holding_area_en || route.path_en || 'Path to darshana';
                          const mins = route.expected_darshan_min;
                          const clockArrival = formatClock(route.expected_darshan_at);

                          return (
                            <div
                              key={rIdx}
                              className={`grid grid-cols-2 items-center ${activeFit ? (loc.routes.length <= 1 ? 'px-2.5 py-3 sm:py-4 flex-1' : 'px-2.5 py-1 sm:py-1.5') : 'px-3 py-2.5'} hover:bg-neutral-50/70 dark:hover:bg-[#191c28] transition-colors`}
                            >
                              <div className="min-w-0 pr-1.5">
                                <span className={`${fs('text-[1.35vw]', 'text-sm sm:text-base')} font-extrabold text-neutral-900 dark:text-neutral-100 block break-words leading-snug`}>
                                  {te && (route.holding_area_te || route.path_te) ? (route.holding_area_te || route.path_te) : pathLabel}
                                </span>
                                {(route.holding_area_te || route.path_te) && (
                                  <div className={`${fs('text-[1vw]', 'text-xs')} font-semibold text-neutral-500 dark:text-neutral-400 break-words leading-tight mt-0.5`}>
                                    {te ? pathLabel : (route.holding_area_te || route.path_te)}
                                  </div>
                                )}
                              </div>
                              <div className="text-right pl-1">
                                {clockArrival ? (
                                  <div className={`${fs('text-[2.2vw]', 'text-base sm:text-lg lg:text-xl')} font-black text-neutral-900 dark:text-neutral-100 tabular-nums leading-tight`}>
                                    {clockArrival}
                                  </div>
                                ) : null}
                                {mins != null && (
                                  <div className={`${fs('text-[1.1vw]', 'text-xs sm:text-sm')} font-bold text-neutral-600 dark:text-neutral-400 tabular-nums leading-tight`}>
                                    {fmtMin(mins)}
                                  </div>
                                )}
                                {!clockArrival && mins == null && (
                                  <span className="text-sm font-bold text-neutral-400">—</span>
                                )}
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>

                  {/* ── Footer Highlight Box ── */}
                  <div className={`${activeFit ? 'p-1.5 pt-0' : 'p-2 pt-0'} bg-white dark:bg-[#151720] shrink-0`}>
                    <div
                      className={`rounded-xl ${activeFit ? 'px-2 py-1' : 'px-2.5 py-2'} ${info.footerBg} border border-neutral-200/70 dark:border-[#242938] grid grid-cols-[1fr_auto_1.15fr] items-center gap-1.5`}
                    >
                      {/* Left: Badge Column */}
                      <div className="flex flex-col items-center justify-center text-center">
                        <div className={`mb-0.5 ${info.accentColor}`}>
                          <ArrowUp className="w-3.5 h-3.5 stroke-[2.8]" />
                        </div>
                        <span
                          className={`${fs('text-[0.95vw]', 'text-xs')} font-black uppercase tracking-tight leading-tight ${info.accentColor} text-center`}
                        >
                          {te ? (FOOTER_TE[info.footerLabel] || info.footerLabel) : info.footerLabel}
                        </span>
                      </div>

                      {/* Divider */}
                      <div className={`w-px ${activeFit ? 'h-6' : 'h-8'} bg-neutral-300/80 dark:bg-neutral-700/80`} />

                      {/* Right: Duration Column */}
                      <div className="flex flex-col items-center justify-center text-center">
                        <span className={`${fs('text-[1.8vw]', 'text-base sm:text-lg')} font-black text-neutral-900 dark:text-neutral-100 tabular-nums leading-none whitespace-nowrap`}>
                          {fastestMin != null ? fmtMin(fastestMin) : '—'}
                        </span>
                        <span className={`${fs('text-[0.95vw]', 'text-xs')} font-bold text-neutral-600 dark:text-neutral-400 whitespace-nowrap mt-0.5`}>
                          {te ? 'దర్శనానికి' : 'to Darshan'}
                        </span>
                      </div>
                    </div>
                  </div>
                  </>)}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* 3. HOLDING AREAS / VINAYAKA Q LINE GPS NAVIGATION SECTION (QR CODES) */}
      <div className={activeFit ? 'shrink-0 pt-0' : 'pt-2'}>
        <div className={`rounded-2xl bg-white dark:bg-[#151720] border border-neutral-200/90 dark:border-[#262b37] ${activeFit ? 'p-2 space-y-1' : 'p-3.5 sm:p-4 space-y-3'} shadow-xs`}>
          {/* Header Strip */}
          <div className={`flex flex-wrap items-center justify-between gap-2 border-b border-neutral-100 dark:border-[#222736] ${activeFit ? 'pb-1' : 'pb-2.5'}`}>
            <div className="flex items-center gap-1.5">
              <span className="p-1 rounded-lg bg-[#dfb052]/15 text-[#dfb052] dark:text-[#f6d887] border border-[#dfb052]/30">
                <MapPin className="w-3.5 h-3.5 stroke-[2.4]" />
              </span>
              <div>
                <h3 className={`${fs('text-[0.9vw]', 'text-xs sm:text-sm')} font-black text-neutral-900 dark:text-[#f6d887] uppercase tracking-wide`}>
                  {!anyHoldingRoutes
                    ? 'VINAYAKA TEMPLE Q LINE GPS NAVIGATION • GOOGLE MAPS'
                    : 'HOLDING AREAS GPS NAVIGATION • GOOGLE MAPS'}
                </h3>
              </div>
            </div>

          </div>

          {/* Panels Grid: Single Vinayaka Q QR card when holding areas not occupied, otherwise 3 Holding Area QR cards */}
          {!anyHoldingRoutes ? (
            <div className="w-full">
              <div
                className={`rounded-xl ${VINAYAKA_QR_DATA.panelClass} bg-neutral-50/70 dark:bg-[rgba(7,29,61,0.75)] border border-neutral-200/80 dark:border-white/10 ${activeFit ? 'p-1.5' : 'p-2.5'} flex flex-col justify-center transition-all hover:border-[#dfb052]/60 hover:shadow-sm`}
              >
                <a
                  href={VINAYAKA_QR_DATA.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={`${VINAYAKA_QR_DATA.title} - Google Maps`}
                  className={`flex items-center justify-between gap-3 sm:gap-6 ${activeFit ? 'p-2 sm:p-2.5' : 'p-3 sm:p-4'} rounded-lg bg-white dark:bg-[rgba(3,18,40,0.85)] border border-neutral-200/80 dark:border-white/15 hover:bg-neutral-100/70 dark:hover:bg-[rgba(6,32,70,0.95)] hover:border-[#dfb052]/60 transition-all group`}
                >
                  <div className="flex flex-col items-start justify-center gap-1.5 flex-1 min-w-0 pr-2">
                    <div className="flex items-center gap-2">
                      <span
                        className={`text-xs font-black px-2.5 py-0.5 rounded-md ${VINAYAKA_QR_DATA.badgeClass} tracking-wider`}
                      >
                        {VINAYAKA_QR_DATA.id}
                      </span>
                      <span className={`text-[11px] font-bold text-neutral-500 dark:text-neutral-400 flex items-center gap-1 ${fs('tv-short-hide', '')}`}>
                        <MapPin className="w-3 h-3 text-amber-500 shrink-0" />
                        Google Maps Live Route • Direct Entry
                      </span>
                    </div>
                    <span className={`${fs('text-[1.3vw]', 'text-xl sm:text-[24px]')} font-black text-neutral-900 dark:text-white leading-snug group-hover:text-amber-600 dark:group-hover:text-[#f6d887] transition-colors break-words`}>
                      {VINAYAKA_QR_DATA.title}
                    </span>
                    <span className={`text-xs sm:text-sm font-medium text-neutral-600 dark:text-neutral-300 leading-snug ${fs('tv-short-hide', '')}`}>
                      {VINAYAKA_QR_DATA.subtitle}
                    </span>
                  </div>
                  <div className={`${activeFit ? 'w-[12vh] h-[12vh] min-w-[72px] min-h-[72px] p-1.5' : 'w-28 h-28 sm:w-32 sm:h-32 p-2'} shrink-0 bg-white rounded-xl shadow-md dark:shadow-[0_4px_14px_rgba(0,0,0,0.65)] flex items-center justify-center border border-neutral-200/80 dark:border-transparent`}>
                    <img
                      src={VINAYAKA_QR_DATA.qrImg}
                      alt={VINAYAKA_QR_DATA.title}
                      className="w-full h-full block [image-rendering:pixelated]"
                      loading="lazy"
                    />
                  </div>
                </a>
              </div>
            </div>
          ) : (
            <div className={`grid ${activeFit ? 'grid-cols-3 gap-0' : 'grid-cols-1 md:grid-cols-3 gap-3'}`}>
              {HOLDING_QR_DATA.map((item) => (
                <div
                  key={item.id}
                  className={`rounded-xl ${item.panelClass} bg-neutral-50/70 dark:bg-[rgba(7,29,61,0.75)] border border-neutral-200/80 dark:border-white/10 ${activeFit ? 'p-1.5' : 'p-2.5'} flex flex-col justify-center transition-all hover:border-[#dfb052]/60 hover:shadow-sm`}
                >
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={`${item.title} - Google Maps`}
                    className={`flex items-center justify-between gap-3 ${activeFit ? 'p-2 sm:p-2.5' : 'p-3'} rounded-lg bg-white dark:bg-[rgba(3,18,40,0.85)] border border-neutral-200/80 dark:border-white/15 hover:bg-neutral-100/70 dark:hover:bg-[rgba(6,32,70,0.95)] hover:border-[#dfb052]/60 transition-all group`}
                  >
                    <div className="flex flex-col items-start justify-center gap-1.5 flex-1 min-w-0 pr-1">
                      <div className="flex items-center gap-2">
                        <span
                          className={`${fs('text-[0.8vw]', 'text-xs')} font-black px-2.5 py-0.5 rounded-md ${item.badgeClass} tracking-wider`}
                        >
                          {item.id}
                        </span>
                        <span className={`${fs('text-[0.7vw]', 'text-[11px]')} font-bold text-neutral-500 dark:text-neutral-400 flex items-center gap-1`}>
                          <MapPin className="w-3 h-3 text-sky-500 shrink-0" />
                          Google Maps Live Route
                        </span>
                      </div>
                      <span className={`${fs('text-[1.2vw]', 'text-xl sm:text-[22px]')} font-black text-neutral-900 dark:text-white leading-snug group-hover:text-sky-600 dark:group-hover:text-[#f6d887] transition-colors break-words`}>
                        {item.title}
                      </span>
                      <span className={`${fs('text-[0.8vw] tv-short-hide', 'text-xs')} font-medium text-neutral-500 dark:text-neutral-400 leading-snug`}>
                        Scan with phone camera for live gate directions
                      </span>
                    </div>
                    <div className={`${activeFit ? 'w-[12vh] h-[12vh] min-w-[72px] min-h-[72px] p-1.5' : 'w-28 h-28 sm:w-32 sm:h-32 p-2'} shrink-0 bg-white rounded-xl shadow-md dark:shadow-[0_4px_14px_rgba(0,0,0,0.65)] flex items-center justify-center border border-neutral-200/80 dark:border-transparent`}>
                      <img
                        src={item.qrImg}
                        alt={item.title}
                        className="w-full h-full block [image-rendering:pixelated]"
                        loading="lazy"
                      />
                    </div>
                  </a>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default DarshanPathsPage;
